import { BaseSelect } from '@app/components';
import { createColumnHelper } from '@tanstack/react-table';
import { IConnector } from '@app/common';
import React from 'react';
import { ResourceSelect, ResourceSelectProps } from '../ResourceSelect';
import { connectorApi } from '@app/store';

const columnHelper = createColumnHelper<IConnector>();

export const ConnectorSelect = ({ label = 'Connecteurs', ...props }: Omit<ResourceSelectProps<IConnector>, 'columns' | 'useQuery'>) => {
  const columns = [
    columnHelper.accessor('name', {
      header: () => (
        <BaseSelect.ListHeaderItem width="100%">
          Nom
        </BaseSelect.ListHeaderItem>
      ),
      cell: (info) => (
        <BaseSelect.ListItemCol width="100%">
          <BaseSelect.ListItemText numberOfLines={1} bold>
            {info.getValue()}
          </BaseSelect.ListItemText>
        </BaseSelect.ListItemCol>
      ),
    }),
  ];

  return (
    <ResourceSelect
      label={label}
      columns={columns}
      useQuery={connectorApi.useReadManyConnectorsQuery}
      {...props} />
  );
};
